export default "__VITE_ASSET__a992c173__"